import { render } from "./report-table.vue?vue&type=template&id=7c068e04"
import script from "./report-table.vue?vue&type=script&lang=js"
export * from "./report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__